//EMPLOYEES_LIST
export const EMPLOYEES_LIST_REQUEST = "EMPLOYEES_LIST_REQUEST";
export const EMPLOYEES_LIST_SUCCESS = "EMPLOYEES_LIST_SUCCESS";
export const EMPLOYEES_LIST_FAIL = "EMPLOYEES_LIST_FAIL";

//EMPLOYEES_LIST_USER_ID
export const EMPLOYEES_USER_ID_LIST_REQUEST = "EMPLOYEES_USER_ID_LIST_REQUEST";
export const EMPLOYEES_USER_ID_LIST_SUCCESS = "EMPLOYEES_USER_ID_LIST_SUCCESS";
export const EMPLOYEES_USER_ID_LIST_FAIL = "EMPLOYEES_USER_ID_LIST_FAIL";

//EMPLOYEES_ALL_SCREENSHOT
export const EMPLOYEES_ALL_SCREENSHOT_REQUEST =
  "EMPLOYEES_ALL_SCREENSHOT_REQUEST";
export const EMPLOYEES_ALL_SCREENSHOT_SUCCESS =
  "EMPLOYEES_ALL_SCREENSHOT_SUCCESS";
export const EMPLOYEES_ALL_SCREENSHOT_FAIL = "EMPLOYEES_ALL_SCREENSHOT_FAIL";

//EMPLOYEES_ALL_CHECKIN
export const EMPLOYEES_ALL_CHECKIN_REQUEST = "EMPLOYEES_ALL_CHECKIN_REQUEST";
export const EMPLOYEES_ALL_CHECKIN_SUCCESS = "EMPLOYEES_ALL_CHECKIN_SUCCESS";
export const EMPLOYEES_ALL_CHECKIN_FAIL = "EMPLOYEES_ALL_CHECKIN_FAIL";

//EMPLOYEES_ALL_ACTIVITY
export const EMPLOYEES_ALL_ACTIVITY_REQUEST = "EMPLOYEES_ALL_ACTIVITY_REQUEST";
export const EMPLOYEES_ALL_ACTIVITY_SUCCESS = "EMPLOYEES_ALL_ACTIVITY_SUCCESS";
export const EMPLOYEES_ALL_ACTIVITY_FAIL = "EMPLOYEES_ALL_ACTIVITY_FAIL";

//EMPLOYEES_ALL_TIMESHEET
export const EMPLOYEES_ALL_TIMESHEET_REQUEST =
  "EMPLOYEES_ALL_TIMESHEET_REQUEST";
export const EMPLOYEES_ALL_TIMESHEET_SUCCESS =
  "EMPLOYEES_ALL_TIMESHEET_SUCCESS";
export const EMPLOYEES_ALL_TIMESHEET_FAIL = "EMPLOYEES_ALL_TIMESHEET_FAIL";

//ADD_ONE_EMPLOYEE_IN_PROJECT
export const ADD_ONE_EMPLOYEE_IN_PROJECT_REQUEST =
  "ADD_ONE_EMPLOYEE_IN_PROJECT_REQUEST";
export const ADD_ONE_EMPLOYEE_IN_PROJECT_SUCCESS =
  "ADD_ONE_EMPLOYEE_IN_PROJECT_SUCCESS";
export const ADD_ONE_EMPLOYEE_IN_PROJECT_FAIL =
  "ADD_ONE_EMPLOYEE_IN_PROJECT_FAIL";

//ADD_ONE_EMPLOYEE_IN_PROJECT_ID
export const ADD_ONE_EMPLOYEE_IN_PROJECT_ID_REQUEST =
  "ADD_ONE_EMPLOYEE_IN_PROJECT_ID_REQUEST";
export const ADD_ONE_EMPLOYEE_IN_PROJECT_ID_SUCCESS =
  "ADD_ONE_EMPLOYEE_IN_PROJECT_ID_SUCCESS";
export const ADD_ONE_EMPLOYEE_IN_PROJECT_ID_FAIL =
  "ADD_ONE_EMPLOYEE_IN_PROJECT_ID_FAIL";

//EMPLOYEE_TIMEPRO_DATE
export const EMPLOYEE_TIMEPRO_DATE_REQUEST = "EMPLOYEE_TIMEPRO_DATE_REQUEST";
export const EMPLOYEE_TIMEPRO_DATE_SUCCESS = "EMPLOYEE_TIMEPRO_DATE_SUCCESS";
export const EMPLOYEE_TIMEPRO_DATE_FAIL = "EMPLOYEE_TIMEPRO_DATE_FAIL";

//EMPLOYEE_TIMEPRO_WEEK
export const EMPLOYEE_TIMEPRO_WEEK_REQUEST = "EMPLOYEE_TIMEPRO_WEEK_REQUEST";
export const EMPLOYEE_TIMEPRO_WEEK_SUCCESS = "EMPLOYEE_TIMEPRO_WEEK_SUCCESS";
export const EMPLOYEE_TIMEPRO_WEEK_FAIL = "EMPLOYEE_TIMEPRO_WEEK_FAIL";

//EMPLOYEE_TIMEPRO_SEVEN
export const EMPLOYEE_TIMEPRO_SEVEN_REQUEST = "EMPLOYEE_TIMEPRO_SEVEN_REQUEST";
export const EMPLOYEE_TIMEPRO_SEVEN_SUCCESS = "EMPLOYEE_TIMEPRO_SEVEN_SUCCESS";
export const EMPLOYEE_TIMEPRO_SEVEN_FAIL = "EMPLOYEE_TIMEPRO_SEVEN_FAIL";

//EMPLOYEES_ALL_TEAMS
export const EMPLOYEES_ALL_TEAMS_REQUEST = "EMPLOYEES_ALL_TEAMS_REQUEST";
export const EMPLOYEES_ALL_TEAMS_SUCCESS = "EMPLOYEES_ALL_TEAMS_SUCCESS";
export const EMPLOYEES_ALL_TEAMS_FAIL = "EMPLOYEES_ALL_TEAMS_FAIL";

//EMPLOYEES_ADD_TIME_IN_PROJECT
export const EMPLOYEES_ADD_TIME_IN_PROJECT_REQUEST =
  "EMPLOYEES_ADD_TIME_IN_PROJECT_REQUEST";
export const EMPLOYEES_ADD_TIME_IN_PROJECT_SUCCESS =
  "EMPLOYEES_ADD_TIME_IN_PROJECT_SUCCESS";
export const EMPLOYEES_ADD_TIME_IN_PROJECT_FAIL =
  "EMPLOYEES_ADD_TIME_IN_PROJECT_FAIL";

//EMPLOYEES_EDIT_TIME_IN_PROJECT
export const EMPLOYEES_EDIT_TIME_IN_PROJECT_REQUEST =
  "EMPLOYEES_EDIT_TIME_IN_PROJECT_REQUEST";
export const EMPLOYEES_EDIT_TIME_IN_PROJECT_SUCCESS =
  "EMPLOYEES_EDIT_TIME_IN_PROJECT_SUCCESS";
export const EMPLOYEES_EDIT_TIME_IN_PROJECT_FAIL =
  "EMPLOYEES_EDIT_TIME_IN_PROJECT_FAIL";

//EMPLOYEES_ALL_REPORT
export const EMPLOYEES_ALL_REPORT_REQUEST = "EMPLOYEES_ALL_REPORT_REQUEST";
export const EMPLOYEES_ALL_REPORT_SUCCESS = "EMPLOYEES_ALL_REPORT_SUCCESS";
export const EMPLOYEES_ALL_REPORT_FAIL = "EMPLOYEES_ALL_REPORT_FAIL";

//EMPLOYEES_ALL
export const EMPLOYEES_ALL_REQUEST = "EMPLOYEES_ALL_REQUEST";
export const EMPLOYEES_ALL_SUCCESS = "EMPLOYEES_ALL_SUCCESS";
export const EMPLOYEES_ALL_FAIL = "EMPLOYEES_ALL_FAIL";

//EMPLOYEES_LIST_USER_ID
export const EMPLOYEES_INVITE_BY_EMAIL_REQUEST =
  "EMPLOYEES_INVITE_BY_EMAIL_REQUEST";
export const EMPLOYEES_INVITE_BY_EMAIL_SUCCESS =
  "EMPLOYEES_INVITE_BY_EMAIL_SUCCESS";
export const EMPLOYEES_INVITE_BY_EMAIL_FAIL = "EMPLOYEES_INVITE_BY_EMAIL_FAIL";

//EMPLOYEES_BLOCK_FROM COMPANY
export const EMPLOYEES_BLOCK_FROM_COMPANY_REQUEST =
  "EMPLOYEES_BLOCK_FROM_COMPANY_REQUEST";
export const EMPLOYEES_BLOCK_FROM_COMPANY_SUCCESS =
  "EMPLOYEES_BLOCK_FROM_COMPANY_SUCCESS";
export const EMPLOYEES_BLOCK_FROM_COMPANY_FAIL =
  "EMPLOYEES_BLOCK_FROM_COMPANY_FAIL";

//EMPLOYEES_DELETE_FROM_COMPANY
export const EMPLOYEES_DELETE_FROM_COMPANY_REQUEST =
  "EMPLOYEES_DELETE_FROM_COMPANY_REQUEST";
export const EMPLOYEES_DELETE_FROM_COMPANY_SUCCESS =
  "EMPLOYEES_DELETE_FROM_COMPANY_SUCCESS";
export const EMPLOYEES_DELETE_FROM_COMPANY_FAIL =
  "EMPLOYEES_DELETE_FROM_COMPANY_FAIL";

//EMPLOYEES_BLOCK_FROM_DEPARTMENT
export const EMPLOYEES_BLOCK_FROM_DEPARTMENT_REQUEST =
  "EMPLOYEES_BLOCK_FROM_DEPARTMENT_REQUEST";
export const EMPLOYEES_BLOCK_FROM_DEPARTMENT_SUCCESS =
  "EMPLOYEES_BLOCK_FROM_DEPARTMENT_SUCCESS";
export const EMPLOYEES_BLOCK_FROM_DEPARTMENT_FAIL =
  "EMPLOYEES_BLOCK_FROM_DEPARTMENT_FAIL";

//UPDATE_EMPLOYEE_DETAILS
export const UPDATE_EMPLOYEE_DETAILS_REQUEST =
  "UPDATE_EMPLOYEE_DETAILS_REQUEST";
export const UPDATE_EMPLOYEE_DETAILS_SUCCESS =
  "UPDATE_EMPLOYEE_DETAILS_SUCCESS";
export const UPDATE_EMPLOYEE_DETAILS_FAIL = "UPDATE_EMPLOYEE_DETAILS_FAIL";

//DELETE_PROJECT_TIME_OF_EMPLOYEE
export const DELETE_PROJECT_TIME_OF_EMPLOYEE_REQUEST =
  "DELETE_PROJECT_TIME_OF_EMPLOYEE_REQUEST";
export const DELETE_PROJECT_TIME_OF_EMPLOYEE_SUCCESS =
  "DELETE_PROJECT_TIME_OF_EMPLOYEE_SUCCESS";
export const DELETE_PROJECT_TIME_OF_EMPLOYEE_FAIL =
  "DELETE_PROJECT_TIME_OF_EMPLOYEE_FAIL";

//SEND_OTP_EMAIL_BY_ADMIN_FOR_USER
export const SEND_OTP_EMAIL_BY_ADMIN_REQUEST =
  "SEND_OTP_EMAIL_BY_ADMIN_REQUEST";
export const SEND_OTP_EMAIL_BY_ADMIN_SUCCESS =
  "SEND_OTP_EMAIL_BY_ADMIN_SUCCESS";
export const SEND_OTP_EMAIL_BY_ADMIN_FAIL = "SEND_OTP_EMAIL_BY_ADMIN_FAIL";

//UPDATE_REASON_IN_EMP_SCREENSHOT
export const UPDATE_REASON_IN_EMP_SCREENSHOT_REQUEST =
  "UPDATE_REASON_IN_EMP_SCREENSHOT_REQUEST";
export const UPDATE_REASON_IN_EMP_SCREENSHOT_SUCCESS =
  "UPDATE_REASON_IN_EMP_SCREENSHOT_SUCCESS";
export const UPDATE_REASON_IN_EMP_SCREENSHOT_FAIL =
  "UPDATE_REASON_IN_EMP_SCREENSHOT_FAIL";

//DELETE_SCREENSHOT
export const DELETE_SCREENSHOT_REQUEST = "DELETE_SCREENSHOT_REQUEST";
export const DELETE_SCREENSHOT_SUCCESS = "DELETE_SCREENSHOT_SUCCESS";
export const DELETE_SCREENSHOT_FAIL = "DELETE_SCREENSHOT_FAIL";

//ADD_EMPLOYEE_IN_DEPARTMENT_OR_PROJECT
export const ADD_EMPLOYEE_IN_DEPARTMENT_OR_PROJECT_REQUEST =
  "ADD_EMPLOYEE_IN_DEPARTMENT_OR_PROJECT_REQUEST";
export const ADD_EMPLOYEE_IN_DEPARTMENT_OR_PROJECT_SUCCESS =
  "ADD_EMPLOYEE_IN_DEPARTMENT_OR_PROJECT_SUCCESS";
export const ADD_EMPLOYEE_IN_DEPARTMENT_OR_PROJECT_FAIL =
  "ADD_EMPLOYEE_IN_DEPARTMENT_OR_PROJECT_FAIL";

//EMPLOYEES_MANAGER_TOTAL_TIME_BY_RANGE
export const EMPLOYEES_MANAGER_TOTAL_TIME_BY_RANGE_REQUEST =
  "EMPLOYEES_MANAGER_TOTAL_TIME_BY_RANGE_REQUEST";
export const EMPLOYEES_MANAGER_TOTAL_TIME_BY_RANGE_SUCCESS =
  "EMPLOYEES_MANAGER_TOTAL_TIME_BY_RANGE_SUCCESS";
export const EMPLOYEES_MANAGER_TOTAL_TIME_BY_RANGE_FAIL =
  "EMPLOYEES_MANAGER_TOTAL_TIME_BY_RANGE_FAIL";
